import type { Admin } from "./admins";

export const SORT_DIRECTIONS = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type SortDirection =
  (typeof SORT_DIRECTIONS)[keyof typeof SORT_DIRECTIONS];

export interface PaginationParams {
  page: number;
  per_page: number;
}

export interface SearchParams {
  search?: string;
}

export interface SortingParams {
  order_by: string | null;
  sort_direction: SortDirection | null;
}

export interface MessageResponse {
  message: string;
}

export interface AuthResponse {
  administrator: Admin;
  accessToken: string;
  expiresIn: number;
  tokenType: string;
}

export interface RefreshResponse {
  accessToken: string;
  expiresIn: number;
  tokenType: string;
}
